import { createFileRoute, Outlet } from '@tanstack/react-router';
import { AutomationsRedirect } from 'src/features/automations/components/AutomationsRedirect';
import { AutomationsNav } from 'src/features/automations/components/AutomationsNav';

export const Route = createFileRoute('/_authenticated/automations')({
  head: () => ({
    meta: [{ title: 'Automations | Tekst' }],
  }),
  component: AutomationsLayout,
});

function AutomationsLayout() {
  return (
    <AutomationsRedirect>
      <AutomationsNav>
        <Outlet />
      </AutomationsNav>
    </AutomationsRedirect>
  );
}
